module.exports = __webpack_public_path__ + "static/media/dry_mode.88481064.png";